// @mui
import { Stack, StackProps, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
//
import { ReactNode, isValidElement } from 'react';
import Image from '../image';

interface EmptyContentProps extends StackProps {
  title: string;
  img?: string;
  description?: ReactNode;
}

export default function EmptyContent({
  title,
  description,
  img,
  sx,
  ...other
}: EmptyContentProps) {
  const theme = useTheme();
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        textAlign: 'center',
        pt: 6,
        pb: 3,
        px: 2,
        ...sx,
      }}
      {...other}
    >
      <Image
        disabledEffect
        alt="empty content"
        src={img || '/assets/illustrations/illustration_empty_content.svg'}
        sx={{
          mb: 3,
          height: 180,
          [theme.breakpoints.up('md')]: {
            height: 240,
          },
        }}
      />

      <Typography
        variant="h5"
        gutterBottom
        sx={{ color: theme.palette.primary.main, textTransform: 'capitalize' }}
      >
        {title}
      </Typography>

      {isValidElement(description) ? (
        description
      ) : (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      )}
    </Stack>
  );
}
